import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-text-center tw-mt-20 md:tw-mt-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "tw-text-[34px] tw-tracking-[0.15px] tw-leading-6 tw-font-semibold tw-text-[#40AE42] md:tw-text-xl tw-mt-9" }, " Hey! Awesome ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-md tw-tracking-[0.4px] tw-leading-5 tw-font-normal tw-text-[#0C0F4A] tw-mt-5 md:tw-text-xs tw-m-auto md:tw-max-w-full" }, " You are closer to fill your escrow wallet ", -1)
const _hoisted_4 = { class: "release__payment tw-bg-[#F1F6FB] tw-py-9 tw-px-[75px] tw-mt-[36px] md:tw-px-[24px]" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "tw-text-2xl tw-tracking-[0.15px] tw-leading-5 tw-font-bold tw-text-[#0C0F4A]" }, " Release Payment for Stage 1 ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-base tw-tracking-[0.25px] tw-leading-5 tw-font-medium tw-text-[#0C0F4A] tw-max-w-[90%] tw-my-[36px] tw-mx-auto" }, " Once approved and released, your tradesperson will receive payment for Phase 1 and the Phase 1 will be marked as complete. ", -1)
const _hoisted_7 = { class: "tw-text-[38px] tw-tracking-[0.25px] tw-leading-10 tw-font-bold tw-text-[#0c0f4a] md:tw-text-3xl" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-tracking-[0.4px] tw-leading-5 tw-font-normal tw-text-[#0c0f4a80] tw-mt-7 tw-max-w-[82%] tw-m-auto md:tw-max-w-full" }, [
  /*#__PURE__*/_createTextVNode(" By confirming you are agreeing to our "),
  /*#__PURE__*/_createElementVNode("strong", { class: "tw-text-[#0c0f4a]" }, " Terms & Conditions "),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", { class: "tw-text-[#0c0f4a]" }, " Privacy Policy.")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "tw-text-xs tw-tracking-[0.4px] tw-leading-5 tw-font-normal tw-text-[#0c0f4a80] tw-mt-7 tw-m-auto md:tw-max-w-full" }, [
  /*#__PURE__*/_createTextVNode(" Additionally, by confirming you are permitting our partner Modulr FS Limited to initiate a payment from your bank account and also agree to their "),
  /*#__PURE__*/_createElementVNode("strong", { class: "tw-text-[#0c0f4a]" }, "Terms & Conditions"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("strong", { class: "tw-text-[#0c0f4a]" }, "Privacy Policy")
], -1)
const _hoisted_10 = { class: "tw-w-full tw-grid tw-grid-cols-2 tw-items-center tw-gap-3 tw-mt-6 md:tw-grid-cols-1" }

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import CurrencyFilter from "@/filters/currency.filter";
import { ref } from "vue";
import CommonLoader from "@/core/components/CommonLoader.vue";
import tradeEstimateService from "@/core/services/trade-estimate.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReleasePaymentModal',
  props: {
  totalPayAmount: {
    type: Number,
  },
},
  emits: ["on-close", "on-confirm"],
  setup(__props, { emit: __emit }) {

const props = __props;
const loading = ref(false);
const formattedCurrency = (value: any) => {
  return CurrencyFilter.formatToCurrency(value);
};
const emits = __emit;
const onCloseModal = () => {
  emits("on-close");
};

const onConfirm = async () => {
  try {
    loading.value = true;
  } catch (error) {
    console.log("error", error);
    emits("on-confirm", false);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "tw-w-[650px] tw-max-w-full md:tw-w-[340px]",
    onOnClose: onCloseModal,
    width: "650px",
    "max-width": "100%"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("h4", _hoisted_7, _toDisplayString(formattedCurrency(__props.totalPayAmount)), 1)
        ]),
        _hoisted_8,
        _hoisted_9
      ]),
      (loading.value)
        ? (_openBlock(), _createBlock(CommonLoader, {
            key: 0,
            loading: loading.value,
            class: "loader-container"
          }, null, 8, ["loading"]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(Button, {
          variant: "tertiary",
          disabled: loading.value,
          label: "Cancel",
          onClick: onCloseModal,
          width: "auto",
          class: "button button-purple-border"
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          variant: "tertiary",
          label: "Approve and release payment",
          isLoading: loading.value,
          onClick: onConfirm,
          width: "auto",
          class: "button button-orange"
        }, null, 8, ["isLoading"])
      ])
    ]),
    _: 1
  }))
}
}

})